/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：681__part-0
 */

"use strict"

var r = {
  "zh-CN": {
    widget: "控件",
    widgetName: "输入框",
    widthMsg: "宽度 ",
    heightMsg: "高度",
    hasErrorMessageLabel: "是否 报错",
    placeholderContent: "提示文案",
    inputContent: "输入文案",
    fontSize: "字号",
    textAlign: "对齐方式",
    left: "居左",
    center: "居中",
    right: "居右",
    outlinedNormal: "线框",
    containedNormal: "底色",
    containedRound: "圆角",
    outlinedFlat: "横线",
    color: "颜色 为",
    templateMode: "的 背景框 样式 为 模板",
    backgroundImage: "的 背景框 样式 为 图片",
    errorMessageContent: "报错文案",
    contentColor: "的 颜色",
    outOfRange: "嵌入积木数值超过取值范围",
    set: "设置"
  }
}
export { r }
